var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 125,
    viewBox: "0 0 248 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.93 65.9197L68.5297 108.16",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.81 59.5197L68.53 108.16L4.21001 120.96M93.81 59.5197L21.81 3.83966M93.81 59.5197L202.93 65.2797L243.25 22.3997",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.84,
    cy: 3.84,
    r: 3.52,
    transform: "matrix(-1 0 0 1 8.0498 117.12)",
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.84,
    cy: 3.84,
    r: 3.52,
    transform: "matrix(-1 0 0 1 72.6904 103.68)",
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.84,
    cy: 3.84,
    r: 3.52,
    transform: "matrix(-1 0 0 1 97.6504 55.6797)",
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.84,
    cy: 3.84,
    r: 3.52,
    transform: "matrix(-1 0 0 1 25.3301 -0.000366211)",
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.84,
    cy: 3.84,
    r: 3.52,
    transform: "matrix(-1 0 0 1 207.09 60.7997)",
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.84,
    cy: 3.84,
    r: 3.52,
    transform: "matrix(-1 0 0 1 247.41 18.5596)",
    fill: "white",
    stroke: "#9FA3A6",
    strokeWidth: 0.64
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphRight);
export default __webpack_public_path__ + "static/media/graph-right.a91eea03ffb4d38e6890cb1824cfee96.svg";
export { ForwardRef as ReactComponent };